// src/app/_services/conflict-transfer.service.ts
import { Injectable } from '@angular/core';
import { Note } from './data.service';  

@Injectable({ providedIn: 'root' })
export class ConflictTransferService {
  localNote: Note | null = null;
  remoteNote: Note | null = null;

  setNotes(local: Note, remote: Note) {
    this.localNote = local;
    this.remoteNote = remote;
  }

  clear() {
    this.localNote = null;
    this.remoteNote = null;
  }
}
